<template>
      <SupplierSKU/>
</template>
<script>
import SupplierSKU from "./SupplierSKU.vue";

export default {
  components: {
    SupplierSKU,
  },
  data() {
    return {

    };
  },
};
</script>
